// extracted by mini-css-extract-plugin
export default {"icon":"ConnectionsNavBar_icon__o44j7","inputMultiQuery":"ConnectionsNavBar_inputMultiQuery__29tft"};